import { LOGO } from "../lib/api";
import { useI18n } from "../lib/LanguageContext";
export default function AboutPage() {
  const { t } = useI18n();
  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="about-page">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-teal mb-3">{t("about.eyebrow")}</div>
      <div className="flex items-center gap-6 mb-8">
        <img src={LOGO} alt="GIDZA" className="h-24"/>
      </div>
      <h1 className="font-display text-4xl md:text-6xl font-medium leading-[1.05] mb-8">{t("about.title")}</h1>
      <div className="prose prose-lg text-muted-foreground max-w-none space-y-6">
        <p>{t("about.p1")}</p>
        <p>{t("about.p2")}</p>
        <p>{t("about.p3")}</p>
      </div>
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        {[
          {t:t("about.mission"),d:t("about.mission_desc")},
          {t:t("about.vision"),d:t("about.vision_desc")},
          {t:t("about.values"),d:t("about.values_desc")},
        ].map((v)=>(
          <div key={v.t} className="bento-tile p-6">
            <div className="text-xs tracking-[0.18em] uppercase text-teal font-bold mb-2">{v.t}</div>
            <p>{v.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
